import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sendGrid = defineConnector({
  identifier: "sendGrid",
  name: "SendGrid",
  tagLine: "Email delivery platform",
  keywords:
    "twilio email api transactional smtp deliverability marketing campaigns",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.sendgrid\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to the [SendGrid dashboard](https://app.sendgrid.com/) and navigate to **Settings** → **API Keys**.\n\nClick **Create API Key**, give it a name, and select the appropriate permissions for your use case.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Paste the API key you just created. **Make sure to copy it now** — SendGrid only shows it once.",
        },
        {
          kind: "input",
          label: "API key",
          placeholder: "SG...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.sendgrid.com/v3/user/profile",
  },
});
